export const HOSTED_AUTH_FAILED_HASH = '#loginFailed';
export const HOSTED_AUTH_SUCCESS_HASH = '#loginSuccess';
